module.exports = __webpack_public_path__ + "img/pegah.9c3d051.png";